import flatpickr from "flatpickr";

// Modal
const modal_trigger = 'modal-book';

const modal = document.querySelector('[data-' + modal_trigger + ']');
let previouslyFocused = null;

function openModal() {
  previouslyFocused = document.activeElement;
  modal.classList.remove('hidden');
  modal.removeAttribute('inert');
  modal.setAttribute('aria-modal', 'true');
  modal.setAttribute('role', 'dialog');
  document.body.style.overflow = 'hidden';
  modal.setAttribute('tabindex', '-1');
  modal.focus();
}

function closeModal() {
  modal.classList.add('hidden');
  modal.setAttribute('inert', '');
  modal.removeAttribute('aria-modal');
  modal.removeAttribute('role');
  modal.removeAttribute('tabindex');
  document.body.style.overflow = '';
  if (previouslyFocused && typeof previouslyFocused.focus === 'function') {
    previouslyFocused.focus();
  }
}

function removeModalHash(){
  if (window.location.hash === '#' + modal_trigger) {
    history.replaceState(null, '', window.location.pathname + window.location.search);
    window.dispatchEvent(new HashChangeEvent('hashchange'));
  }
}

modal.addEventListener('keydown', (e) => {
  switch (e.key) {
    case 'Escape':
      removeModalHash();
      break;
    case 'Tab': 
      const focusable = modal.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');
      const first = focusable[0];
      const last = focusable[focusable.length - 1];
      if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        first.focus();
      } else if (e.shiftKey && document.activeElement === first) {
        e.preventDefault();
        last.focus();
      }
      break;
  }
});

modal.addEventListener('click', (e) => {
  if (e.target === modal) {
    removeModalHash();
  }
});

modal.querySelector('.close-modal').addEventListener('click', (e) => {
  e.preventDefault();
  removeModalHash();
});

if (window.location.hash === '#' + modal_trigger) {
  openModal();
}

window.addEventListener('hashchange', () => {
  if (window.location.hash === '#' + modal_trigger) {
    let link_venue = null;
    if(document.activeElement?.dataset?.venue) {
      link_venue = document.activeElement?.dataset?.venue;
    }else if(document.activeElement?.closest('main')?.closest('body.single-venue')){
      const match = document.body.className.match(/postid-(\d+)/);
      link_venue = parseInt(match[1]) || null;
    }

    updateBookPopupVenue(link_venue);
    openModal();
  } else {
    closeModal();
  }
});

// Venue Update
const updateBookPopupVenue = (venue_id) => {
  const venue = get_venue_info(venue_id) ? get_venue_info(venue_id) : get_current_venue_info();
  const modal = document.querySelector('[data-modal-book]');

  if(!venue || !modal) return;

  const venueName = modal.querySelector('.venue-name');
  const venueAddress = modal.querySelector('.venue-address');
  const venuePhone = modal.querySelector('.venue-phone');
  const form = modal.querySelector('.book-popup-form');
  
  if(venue.name){
    venueName.innerText = venue.name;
    venueName.classList.remove('hidden');
  }else{
    venueName.classList.add('hidden');
  }
  
  if(venue.address){
    venueAddress.innerText = venue.address;
    venueAddress.classList.remove('hidden');
  }else{
    venueAddress.classList.add('hidden');
  }
  
  if(venue.telephone){
    venuePhone.innerText = venue.telephone;
    venuePhone.classList.remove('hidden');
  }else{
    venuePhone.classList.add('hidden');
  }

  if(venue.table_url){
    form.action = venue.table_url;
    form.classList.remove('hidden');
  }else{
    form.action = '';
    form.classList.add('hidden');
  }
}

updateBookPopupVenue();
document.body.addEventListener('venueChanged', updateBookPopupVenue);

// Form
const form = document.querySelector('.book-popup-form');

if(form) {
  const datepicker = form.querySelector('.book-popup-form-date');
  if (datepicker) {
    const today = new Date();
    const yyyy = today.getFullYear();
    const mm = String(today.getMonth() + 1).padStart(2, '0');
    const dd = String(today.getDate()).padStart(2, '0');
    const minDate = `${yyyy}-${mm}-${dd}`;
    const maxDateObj = new Date(today.getTime() + 30 * 24 * 60 * 60 * 1000);
    const maxyyyy = maxDateObj.getFullYear();
    const maxmm = String(maxDateObj.getMonth() + 1).padStart(2, '0');
    const maxdd = String(maxDateObj.getDate()).padStart(2, '0');
    const maxDate = `${maxyyyy}-${maxmm}-${maxdd}`;
    datepicker.setAttribute('min', minDate);
    datepicker.setAttribute('max', maxDate);

    flatpickr(datepicker, {
      dateFormat: 'M j, Y',
      minDate: today,
      maxDate: maxDateObj,
      monthSelectorType: 'static',
    });
  }  

  const timepicker = form.querySelector('.book-popup-form-time');
  if(timepicker){
    const options = Array.from(timepicker.querySelectorAll('option')).filter(opt => !opt.disabled);

    const now = new Date();
    const currentMinutes = now.getHours() * 60 + now.getMinutes();

    const parsedOptions = options.map(opt => {
      const [h, m] = opt.value.split(':').map(Number);
      const minutes = h * 60 + m;
      return { opt, minutes };
    });

    let firstIdx = parsedOptions.findIndex(({ minutes }) => minutes > currentMinutes);
    if (firstIdx === -1) firstIdx = 0;

    const reordered = [
      ...parsedOptions.slice(firstIdx),
      ...parsedOptions.slice(0, firstIdx)
    ];

    const placeholder = timepicker.querySelector('option[disabled]');
    timepicker.innerHTML = '';
    if (placeholder) timepicker.appendChild(placeholder.cloneNode(true));

    reordered.forEach(({ opt }) => {
      timepicker.appendChild(opt.cloneNode(true));
    });
  }

  form.addEventListener('submit', (e) => {
    e.preventDefault();

    const g = form.querySelector('.book-popup-form-guests').value;
    const d = form.querySelector('.book-popup-form-date').value;
    const t = form.querySelector('.book-popup-form-time').value;

    const date = new Date(d);
    const yyyy = date.getFullYear();
    const mm = String(date.getMonth() + 1).padStart(2, '0');
    const dd = String(date.getDate()).padStart(2, '0');
    
    const datetime = `${yyyy}-${mm}-${dd}T${t}`;

    const baseUrl = form.action || '';
    const url = new URL(baseUrl, window.location.origin);
    url.searchParams.set('datetime', datetime);
    url.searchParams.set('covers', g);

    window.open(url, '_blank', 'noopener');
  });
}